/* Brand-only adapter around the existing shared masked video player. */
const root = document.querySelector('.bk-approved');
if (root) {
  const breadcrumb = document.querySelector('.ho-breadcrumbs [aria-current="page"]');
  if (breadcrumb) breadcrumb.textContent = 'Broil King';
}
const script = document.querySelector('script[data-bk-player]');
const media = root?.querySelector('.bka-ique-media');
if (media && script) {
  const host = media.querySelector('[data-bk-video]');
  const button = media.querySelector('.bka-play');
  let pending;
  async function mount() {
    if (pending) return pending;
    pending = import(script.dataset.bkPlayer).then(({ mountPdpVideo }) => {
      mountPdpVideo(host, {
        youtubeId: 'Cw3ii6LODbE',
        title: 'iQue Overview · Series video',
        pauseOffscreen: true,
        eager: true
      });
      media.dataset.mounted = 'true';
    }).catch(() => { pending = null; });
    return pending;
  }
  button.addEventListener('click', async () => {
    const alreadyMounted = media.dataset.mounted === 'true';
    await mount();
    const control = host.querySelector('.video-controls button');
    if (alreadyMounted && control?.getAttribute('aria-label') === 'Play video') control.click();
    control?.focus({ preventScroll: true });
  });
  // Respect reduced motion: only an explicit play request mounts the player.
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); mount(); }
    }, { threshold: 0.25 });
    observer.observe(media);
  }
  window.addEventListener('message', event => {
    const frame = host.querySelector('iframe');
    if (event.origin !== 'https://www.youtube-nocookie.com' || event.source !== frame?.contentWindow) return;
    let data;
    try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } catch { return; }
    const state = data?.event === 'onStateChange' ? data.info : data?.info?.playerState;
    if (state === 1) media.dataset.playing = 'true';
  });
}
